import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import ProcedureModal from "../../core/modals/procedures/ProcedureModal";
import { fetchProcedures, deleteProcedureThunk } from "../../core/redux/slices/procedureSlice";

const ProcedureList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.procedures);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchProcedures()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((p) => !q || p.procedureName?.toLowerCase().includes(q));
  }, [list, search]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchProcedures()); };

  const columns = [
    { title: "Procedure Name", dataIndex: "procedureName", sorter: (a, b) => a.procedureName.localeCompare(b.procedureName) },
    { title: "Description", dataIndex: "description", ellipsis: true },
    { title: "Duration (min)", dataIndex: "defaultDuration", width: 110, align: "center" },
    { title: "Normal Charge (₹)", dataIndex: "chargeNormal", width: 140, align: "right",
      render: (v) => v != null ? `₹${Number(v).toLocaleString("en-IN")}` : "—" },
    { title: "Arab Charge (₹)", dataIndex: "chargeArab", width: 130, align: "right",
      render: (v) => v != null ? `₹${Number(v).toLocaleString("en-IN")}` : "—" },
    { title: "Tax", dataIndex: "taxApplicable", width: 80, align: "center",
      render: (v) => <span className={`badge bg-${v ? "success" : "secondary"}`}>{v ? "Yes" : "No"}</span> },
    { title: "Status", dataIndex: "status", width: 90,
      render: (v) => <span className={`badge bg-${v === "Active" ? "success" : "danger"}`}>{v}</span> },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="edit-delete-action d-flex">
          <button className="me-2 p-2 btn btn-sm" onClick={() => openEdit(rec)}><Edit size={15} /></button>
          <button className="p-2 btn btn-sm text-danger" onClick={() => confirmDelete(() => dispatch(deleteProcedureThunk(rec.id)), rec.procedureName)}>
            <Trash2 size={15} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Procedures" subtitle="Manage dental procedures and charges" onAdd={openAdd} addLabel="Add Procedure" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-input">
                <input type="text" placeholder="Search procedures..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <ProcedureModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default ProcedureList;
